import { pagesSection, settingsSection, useCasesSection } from './sections-navigation';
import {
  callsSection,
  clientsSection,
  customPresetsSection,
  documentationSection,
  documentsSection,
  emailsSection,
  excelTemplatesSection,
  formsSection,
  knowledgeBasesSection,
  knowledgeDocumentsSection,
  serviceRequestsSection,
  sharedPresetsSection,
  stylesSection,
  templatesSection,
  triggerExecutionsSection,
  triggersSection,
  voiceAgentsSection,
  wordTemplatesSection,
  workspacesSection
} from './sections-records';
import type { SearchAccess, SearchSection } from './types';

/**
 * Every resource universal search covers, in the order groups appear in the
 * palette: the sections that answer instantly first, so the list settles from
 * the top down instead of reflowing under the cursor as slower ones land.
 */
export const searchSections: SearchSection[] = [
  pagesSection,
  settingsSection,
  useCasesSection,
  customPresetsSection,
  sharedPresetsSection,
  templatesSection,
  wordTemplatesSection,
  excelTemplatesSection,
  stylesSection,
  formsSection,
  knowledgeBasesSection,
  voiceAgentsSection,
  triggersSection,
  workspacesSection,
  documentsSection,
  knowledgeDocumentsSection,
  emailsSection,
  callsSection,
  serviceRequestsSection,
  triggerExecutionsSection,
  clientsSection,
  documentationSection
];

export const visibleSearchSections = (access: SearchAccess) =>
  searchSections.filter((section) => !section.hidden?.(access));
